"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowsMetadata = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ShowsContextCard_1 = require("../../Cards/ShowsContextCard");
/**
 * Contains all of the metadata which should be displayed when showing Shows content in a web player.
 */
function ShowsMetadata({ showsContextCardInfo }) {
    if (showsContextCardInfo) {
        return ((0, jsx_runtime_1.jsx)(ShowsContextCard_1.ShowsContextCard, { publisherDisplayName: showsContextCardInfo.publisherDisplayName, episodeInfo: showsContextCardInfo.episodeInfo }));
    }
    return (0, jsx_runtime_1.jsx)("div", {});
}
exports.ShowsMetadata = ShowsMetadata;
//# sourceMappingURL=ShowsMetadata.js.map